var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_4678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0811 12.242H32.7411L29.2771 6.242H18.8851L15.4211 12.242H8.08106C5.88106 12.242 4.08105 14.042 4.08105 16.242V34.242C4.08105 36.442 5.88106 38.242 8.08106 38.242H40.0811C42.2811 38.242 44.0811 36.442 44.0811 34.242V16.242C44.0811 14.042 42.2811 12.242 40.0811 12.242ZM42.0811 34.242C42.0811 35.345 41.1841 36.242 40.0811 36.242H8.08106C6.97806 36.242 6.08105 35.345 6.08105 34.242V16.242C6.08105 15.139 6.97806 14.242 8.08106 14.242H15.4211H16.5761L17.1531 13.242L20.0401 8.242H28.1231L31.0101 13.242L31.5871 14.242H32.7421H40.0821C41.1851 14.242 42.0821 15.139 42.0821 16.242V34.242H42.0811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0811 18.242C20.7671 18.242 18.0811 20.928 18.0811 24.242C18.0811 27.556 20.7671 30.242 24.0811 30.242C27.3951 30.242 30.0811 27.556 30.0811 24.242C30.0811 20.928 27.3951 18.242 24.0811 18.242ZM24.0811 28.242C21.8751 28.242 20.0811 26.448 20.0811 24.242C20.0811 22.036 21.8751 20.242 24.0811 20.242C26.2871 20.242 28.0811 22.036 28.0811 24.242C28.0811 26.448 26.2871 28.242 24.0811 28.242Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_4678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.53c795c2ca14718e822a3fee36069118.svg";
export { ForwardRef as ReactComponent };